import { useState, useEffect } from 'react';
import { usePrevious } from '@ui/src';

import useNetworkStatus from '../../hooks/use-network-status';

import styles from './layout.module.css';

const NetworkStatusBanner = () => {
  const [networkStatusRestored, setNetworkStatusRestored] = useState(false);

  const { isOnline } = useNetworkStatus();
  const prevIsOnline = usePrevious(isOnline);

  useEffect(() => {
    if (isOnline && !prevIsOnline && prevIsOnline !== null) {
      setNetworkStatusRestored(true);
    }
  }, [isOnline]);

  useEffect(() => {
    if (networkStatusRestored) {
      setTimeout(() => {
        setNetworkStatusRestored(false);
      }, 5000);
    }
  }, [networkStatusRestored]);

  return (
    <>
      {!isOnline && (
        <div className={styles.networkConnection}>
          <div className={styles.connectionCircle} />
          Internet connection lost
        </div>
      )}
      {networkStatusRestored && (
        <div className={styles.networkConnection}>
          <div
            className={`${styles.connectionCircle} ${styles.connectionCircleRestored}`}
          />
          Internet connection restored
        </div>
      )}
    </>
  );
};

export default NetworkStatusBanner;
